/*=================================================
=            Variables d'environnement            =
=================================================*/
var taille = jQuery(window).width();
var tailleTablet = 768;
var tailleDesktop = 992;
var menuElement;
var menuParent;

jQuery(document).ready(function(){
    
    /*	--------------------------------------------------
	== pour ajouter la croix pour fermer le menu principal
	-------------------------------------------------- */
    jQuery('.menu-primary').append('<div class="menu-close"></div>');
	

	/*	--------------------------------------------------
    == pour fermer le menu
	-------------------------------------------------- */
    jQuery('.menu-close').click(function () {
		jQuery('.navbar-collapse').removeClass('show');
        jQuery('.navbar-toggler').addClass('collapsed');
    });


	/*	--------------------------------------------------
	== menu fixed au scroll
	-------------------------------------------------- */
	jQuery(window).on('scroll', function() {
	    jQuery('.header').toggleClass('js-fixed-me', jQuery(this).scrollTop() > 110);
	});
	jQuery(window).on('scroll', function() {
	    jQuery('.header').toggleClass('js-fixed-me-2', jQuery(this).scrollTop() > 111);
	});


	/*	--------------------------------------------------
    == slider homepage
	-------------------------------------------------- */
	if(jQuery('[data-slider=fn_homepage__slider]').length){
		jQuery('[data-slider=fn_homepage__slider]').slick({
			dots: true,
			arrows: false,
			autoplay: true,
			autoplaySpeed: 3000,
			fade: true,
			pauseOnHover: false
		});
	}


	/*	--------------------------------------------------
	== Animate on scroll library
	-------------------------------------------------- */
	AOS.init();


	/*==================================
	=            Responsive            =
	==================================*/

	// fonction executée au chargement de la page et à chaque modification de largeur du navigateur
	function screenChange()
    {
		taille = jQuery(window).width();

		if (taille >= tailleDesktop) {

			/*	--------------------------------------------------
			== redéplacer widgets header dans le menu desktop
			-------------------------------------------------- */
			jQuery('.header').append( jQuery('.menu-primary > .header__widgets') ); // à commenter si header avec un .container
			//jQuery('.header > .container').append( jQuery('.menu-primary > .header__widgets') ); // à décommenter si header avec un .container

		}
		else {

			/*	--------------------------------------------------
			== déplacer widgets header dans le menu mobile
			-------------------------------------------------- */
			jQuery('.menu-primary').append( jQuery('.header > .header__widgets') ); // à commenter si header avec un .container
			//jQuery('.menu-primary').append( jQuery('.header > .container > .header__widgets') ); // à décommenter si header avec un .container

		}
	}

	screenChange();

	jQuery(window).resize(function()
    {
		if (taille != jQuery(window).width()) {
			screenChange();
		}
	});

	/*=====  End of Responsive  ======*/

});

replaceAOSDataAttributes();

/**
 * Replace the data-attributes for AOS animations to prevent content display with JavaScript disabled in the browser
 */
function replaceAOSDataAttributes() {
    const elementsHTML = document.querySelectorAll('[data-z-aos]');

    elementsHTML.forEach(elementHTML => {
        const animationName = elementHTML.getAttribute('data-z-aos');

        elementHTML.setAttribute('data-aos', animationName);

        elementHTML.removeAttribute('data-z-aos');

		const animationDuration = elementHTML.getAttribute('data-z-aos-duration');

        elementHTML.setAttribute('data-aos-duration', animationDuration);

        elementHTML.removeAttribute('data-z-aos-duration');
    })
}

document.querySelectorAll('.section_cards .row').forEach(function(row) {
    const cards = row.querySelectorAll('.card-col');

    if (cards.length > 3) {
        row.classList.add('is-slider');
    }
});

document.addEventListener('DOMContentLoaded', function () {
    var confirmation = document.querySelector('#gform_confirmation_wrapper_1');

    if (!confirmation) {
        return;
    }

    var offset = 120;
    var top = confirmation.getBoundingClientRect().top + window.pageYOffset - offset;

    window.scrollTo({
        top: top,
        behavior: 'smooth'
    });
});
